import { useEffect, useState } from 'react';

export function useBraintreeState({ onInitialPaymentMethodRequestable }) {
  const [braintree, setBraintreeInstance] = useState();
  const paymentMethodRequestable = !!braintree?.isPaymentMethodRequestable();

  useEffect(() => {
    paymentMethodRequestable && onInitialPaymentMethodRequestable();
  }, [onInitialPaymentMethodRequestable, paymentMethodRequestable]);

  return { braintree, setBraintreeInstance };
}
